import { Feature } from '@wwt/entities/search-response'

import { GroupAllFeaturesInnerType } from './groupAllFeaturesTypes.ts'

export const baseExtractFeaturesAndGroups = (
	featuresInput: Feature[]
): GroupAllFeaturesInnerType => {
	const groups: GroupAllFeaturesInnerType['groups'] = {}
	const features: GroupAllFeaturesInnerType['features'] = {}
	const ids: GroupAllFeaturesInnerType['ids'] = []

	featuresInput.forEach(feature => {
		const groupName = feature.group?.name ?? 'null'

		if (!groups[groupName]) {
			groups[groupName] = feature.group ?? { name: 'null' }
		}

		if (!features[groupName]) {
			features[groupName] = []
		}

		if (!ids.includes(groupName)) {
			ids.push(groupName)
		}

		features[groupName].push(feature)
	})

	return { groups, features, ids }
}
